/**
 * @desc 请求
 */
const URL = "/rantion-esca";
import http, { updateResponse } from "@/http";
export function request(body: defs.esca.CaApiRequestParamDto, options?: any) {
  return updateResponse(
    http(URL + `/caApi/request`, {
      method: "POST",

      data: body,
      ...options,
    }),
  );
}
